import { createHttpClient } from 'shared/api/createHttpClient'
import type {
  AdLoginRequest,
  AuthTokensResponse,
  WebviewAuthRequest,
  WebviewAuthResponse,
} from '../model/types'

export async function adLogin(payload: AdLoginRequest): Promise<AuthTokensResponse> {
  const client = createHttpClient()
  return client.post<AuthTokensResponse>('/user/ad-login/', payload)
}

export async function authenticateWebview(
  payload: WebviewAuthRequest
): Promise<WebviewAuthResponse> {
  const client = createHttpClient()
  return client.post<WebviewAuthResponse>('/work/webview/auth/', payload)
}

export async function closeWebviewApp(): Promise<void> {
  const client = createHttpClient()
  await client.post('/work/webview/close-app/', {})
}
